module.exports = __webpack_public_path__ + "img/5.2a09ac2f.gif";